// extracted by mini-css-extract-plugin
module.exports = {"table-vertical-align":"style_table-vertical-align__2NnuF"};